import { render, staticRenderFns } from "./riding.vue?vue&type=template&id=09315ad5&scoped=true&"
import script from "./riding.vue?vue&type=script&lang=js&"
export * from "./riding.vue?vue&type=script&lang=js&"
import style0 from "./riding.vue?vue&type=style&index=0&id=09315ad5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09315ad5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09315ad5')) {
      api.createRecord('09315ad5', component.options)
    } else {
      api.reload('09315ad5', component.options)
    }
    module.hot.accept("./riding.vue?vue&type=template&id=09315ad5&scoped=true&", function () {
      api.rerender('09315ad5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/riding.vue"
export default component.exports